import React from "react";
import { BeatLoader } from "react-spinners";
import { BoxLoader } from "./Loader.style";

const Loader = () => {
  return (
    <BoxLoader>
      <BeatLoader />
    </BoxLoader>
  );
};

export default Loader;
